<!-- <button mat-raised-button class="edit-button" [disabled]="flag_PC_in_editare"
(click)="editeazaPersoanaContact(element)">editeaza</button> -->

<button mat-raised-button class="edit-button" (click)="editBtnClick()">editeaza</button>
